module.exports = __webpack_public_path__ + "media/images/careers/dpcl-d6f89bb166aee88c056e6ca62ec6f8b0.svg";